import React, { createContext, useContext } from 'react';
import { RootStore } from './RootStore';

const StoreContext = createContext();

export function StoreProvider({ children }) {
  const rootStore = new RootStore();
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;
}

export function useUserStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'useUserStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context.userStore;
}

export function useGamesStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'useGamesStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context.gamesStore;
}

export function useHighlightsStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'useHighlightsStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context.highlightsStore;
}

export function usePostsStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'usePostsStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context.postsStore;
}

export function useOrganizationStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'useOrganizationStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context.organizationStore;
}



export function useStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      'useStore could not find StoreContext, please use StoreProvider as a wrapper.',
    );
  }
  return context;
} 